import axios from "axios";

export const createBomUserDetails = (formData) => {
  const url = "/departments"
  const method = !formData.id?"POST":"PUT"
  const response = axios({
    url:url,
    method:method,
    data:formData,
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    console.log(response.data.message)
    if(response.data.success){
      return {success:true,message:response.data.message}
    }else{
      return {success:false, message:response.data.message}
    }  
  })
  return response
}

export const getDepartmentsList = async (params) => {
  let query = new URLSearchParams(params).toString();
  const response = await axios({
    url:`/departments?${query}`,
    method:"GET",
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  })
  return response
}

const departmentsService = {
  createBomUserDetails,
  getDepartmentsList
}

export default departmentsService;